export class SessionStorage {
  /**
   *
   *
   * @static
   * @param {boolean} value
   * @memberof SessionStorage
   */
  public static setStorage(value: boolean): void {
    if (value === true) {
      sessionStorage.setItem('sliderView', 'true');
    } else {
      sessionStorage.removeItem('sliderView');
    }
  }

  /**
   *
   *
   * @static
   * @returns {boolean}
   * @memberof SessionStorage
   */
  public static getStorage(): boolean {
    if (sessionStorage.getItem('sliderView') === 'true') {
      return true;
    } else {
      return false;
    }
  }
}
